import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const newsletterAudienceListContacts = {
  list: ({
    newsletterId,
    listId,
    params = {},
  }: {
    listId: number;
    newsletterId: number;
    params?: Params;
  }) =>
    buildPath(
      `/internal_api/newsletters/${newsletterId}/lists/${listId}/list_contacts`,
      params,
    ),
};
